export default __webpack_public_path__ + "static/media/dropdown-up-arrow.af22fc64.svg";